import { useState, useEffect } from 'react'; 
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap'; 
import { Link, useNavigate } from 'react-router-dom'; 
import { FaPenSquare, FaCogs, FaUser, FaComments, FaCheckCircle, FaBook, FaPhone, FaFax, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './HomePage.css';
import imgProfesional from '../assets/images/profesional.png';
import imgTransparan from '../assets/images/transparan.png';
import imgTerpercaya from '../assets/images/terpercaya.jpg';
import authService from '../services/authService'; 

const HomePage = () => {
    const [currentUser, setCurrentUser] = useState(undefined);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const user = authService.getCurrentUser();
        if (user) {
            setCurrentUser(user);
        }
    }, []);

    const handleModalClose = () => setShowModal(false);

    const handleLogout = () => {
        authService.logout();
        setShowModal(false);
        window.location.reload(); 
    };
    
    // PERUBAHAN: Klik tombol pengaduan langsung mengarah ke halaman pelaporan tanpa dipaksa login
    const handlePortalClick = () => {
        navigate('/dashboard/buat-laporan');
    };

    return (
        <>
            <div className="hero-banner">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <h1>SIPUMA ASSISTANT</h1>
                            <p>Sistem Informasi & Pengaduan Masyarakat Online Terintegrasi Direktorat Jenderal Bea dan Cukai</p>
                            <div className="mt-4">
                                <Button variant="warning" size="lg" className="me-3 fw-bold text-dark px-4" onClick={handlePortalClick}>
                                    <FaPenSquare className="me-2" /> Masuk Menu Pelaporan
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="alur-pengaduan-section py-5 bg-light">
                <Container>
                    <div className="text-center mb-5">
                        <h2 className="fw-bold">Prinsip Pelayanan Kami</h2>
                    </div>
                    <Row>
                        <Col md={4} className="mb-4">
                            <Card className="text-center border-0 shadow-sm h-100 p-3">
                                <Card.Img variant="top" src={imgProfesional} style={{ height: '120px', objectFit: 'contain' }} />
                                <Card.Body>
                                    <Card.Title className="fw-bold">Profesional</Card.Title>
                                    <Card.Text>Menangani setiap aduan secara cepat, terukur, dan sesuai ketentuan.</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-4">
                            <Card className="text-center border-0 shadow-sm h-100 p-3">
                                <Card.Img variant="top" src={imgTransparan} style={{ height: '120px', objectFit: 'contain' }} />
                                <Card.Body>
                                    <Card.Title className="fw-bold">Transparan</Card.Title>
                                    <Card.Text>Status penanganan perkara dapat dipantau langsung secara terbuka.</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-4">
                            <Card className="text-center border-0 shadow-sm h-100 p-3">
                                <Card.Img variant="top" src={imgTerpercaya} style={{ height: '120px', objectFit: 'contain' }} />
                                <Card.Body>
                                    <Card.Title className="fw-bold">Aman & Terpercaya</Card.Title>
                                    <Card.Text>Identitas, rahasia data, dan privasi chat Anda dijamin aman tanpa kebocoran.</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="info-pengaduan-section py-5">
                <Container>
                    <Row>
                        <Col md={12}>
                            <Card className="border-0 shadow-sm bg-primary text-white p-4">
                                <Card.Body>
                                    <h4 className="fw-bold mb-3">Kontak Resmi Pengaduan</h4>
                                    <ul className="list-unstyled contact-list">
                                        <li><FaPhone className="icon" /> (021) 1500 225 (Bravo Bea Cukai)</li>
                                        <li><FaFax className="icon" /> (021) 4890966</li>
                                        <li><FaEnvelope className="icon" /> pengaduan.beacukai@customs.go.id</li>
                                        <li><FaMapMarkerAlt className="icon" /> Surat: d.a. Direktur Kepatuhan Internal Kantor Pusat Bea Cukai</li>
                                    </ul>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal show={showModal} onHide={handleModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Peringatan</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Anda sudah login sebagai <strong>{currentUser?.username}</strong>.<br /> Ingin logout?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>Tutup</Button>
                    <Button variant="danger" onClick={handleLogout}>Logout</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default HomePage;